export default "__VITE_ASSET__41971d86__"